import React from 'react';
import { AppLogo } from '../../pages/icons';
import * as S from './styled';

interface FLLogoProps {
  hideOnMobile?: boolean;
}

export interface MainLayoutProps extends FLLogoProps {
  children?: any;
  customStyles?: string;
  withLogo?: boolean;
  autoHeight?: boolean;
}

export const FLLogo = ({ hideOnMobile = true }: FLLogoProps) => {
  return (
    <S.LogoWrapper $hideOnMobile={hideOnMobile}>
      {AppLogo}
      <span>FAMILY LOCATOR</span>
    </S.LogoWrapper>
  );
};

export const MainLayout = ({
  children,
  customStyles,
  withLogo,
  autoHeight,
  hideOnMobile,
}: MainLayoutProps) => {
  return (
    <S.StyledLayout $customStyles={customStyles} $autoHeight={autoHeight}>
      {withLogo && <FLLogo hideOnMobile={hideOnMobile} />}
      {children}
    </S.StyledLayout>
  );
};
